























































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { CustomerInsuranceModel } from '@/app/shared/models';
@Component
export default class ContentCustomerInsuranceComponent extends Vue {
  private get refs() {
    return refsService;
  }
  private get customer(): CustomerInsuranceModel {
    return this.refs.modules.policy.customer;
  }
  private get email() {
    return this.refs.util.findEmail(this.customer.Contacts);
  }
  private get phone() {
    const phone = this.refs.util.findPhone(this.customer.Contacts);
    return phone
      ? this.refs.util.createMask(phone.Value, '(##) ####-####')
      : undefined;
  }
  private get cellPhone() {
    const cellPhone = this.refs.util.findCellphone(this.customer.Contacts);
    return cellPhone
      ? this.refs.util.createMask(cellPhone.Value, '(##) #####-####')
      : undefined;
  }
  private get document() {
    return this.customer.DocumentType && this.customer.Document
      ? `${this.customer.DocumentType} - ${this.refs.util.createMask(
          this.customer.Document,
          this.customer.DocumentType == 'CPF'
            ? '###.###.###-##'
            : '##-###-###/####-##'
        )}`
      : this.customer.DocumentType || this.customer.Document || '--';
  }
  private get address() {
    const address = this.refs._.head(this.customer.Addresses);
    return address
      ? `${address.Street || '--'},
      ${address.Neighborhood || '--'},
      ${address.Complement || '--'},
      ${address.Number || '--'},
      ${address.City || '--'},
      ${address.SubdivisionCode || '--'},
      ${
        address.PostalCode
          ? this.refs.util.createMask(address.PostalCode, '##.###-###')
          : '--'
      }`
      : undefined;
  }
}
